/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import { Button } from 'reactstrap';
import LockImage from '../../../../images/assessment-lock/lock-icon.png';
import './LockedSection.scss';

interface LockedSectionProps {
  title: string;
  features: string[];
  buttonText: string;
  onUnlock: () => void;
  backgroundImage?: string;
}

export const LockedSection = ({ title, features, buttonText, onUnlock, backgroundImage }: LockedSectionProps) => {
  const sectionStyle = backgroundImage
    ? {
        backgroundImage: `url(${backgroundImage})`,
      }
    : undefined;

  return (
    <div className='locked-section' style={sectionStyle}>
      <div className='locked-section__content'>
        <img src={LockImage} alt='Lock icon' className='locked-section__icon' />
        <h2 className='locked-section__title'>{title}</h2>
        <ul className='locked-section__features'>
          {features.map((feature, index) => (
            <li key={index} className='locked-section__feature'>
              <i className='fal fa-check text-primary mr-2' />
              {feature}
            </li>
          ))}
        </ul>
        <Button color='primary' size='lg' onClick={onUnlock}>
          {buttonText}
        </Button>
      </div>
    </div>
  );
};
